/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1
     */
    'cardType': BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum = typeof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum[keyof typeof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf1CardTypeEnum];


